import { Helmet } from 'react-helmet';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeatureSection from './components/FeatureSection';
import ArticleSection from './components/ArticleSection';
import FAQSection from './components/FAQSection';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  return (
    <>
      <Helmet>
        <title>夜猫电影院 - 夜间追剧不缓冲高清在线观看 | 深夜影院免费电视剧全集</title>
        <meta name="description" content="夜猫电影院专为夜间追剧打造，深夜影院免费在线观看高清电影、电视剧，不缓冲不卡顿，熬夜看剧首选，午夜剧场海量片源，满足你的夜猫子观影需求。" />
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '夜猫电影院',
            url: 'https://yemaocinema.com/',
            description: '夜猫电影院专为夜间追剧打造，深夜影院免费在线观看高清电影、电视剧，不缓冲不卡顿。',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://yemaocinema.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '夜猫电影院',
            url: 'https://yemaocinema.com/',
            description: '夜猫电影院专为夜间追剧打造，深夜影院免费在线观看高清电影、电视剧。',
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '夜猫电影院需要付费吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '完全免费！夜猫电影院所有电影、电视剧、动漫、综艺资源均可免费在线观看，无需任何会员费用。',
                },
              },
              {
                '@type': 'Question',
                name: '为什么选择深夜观影？平台有什么优势？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '夜猫电影院针对夜间网络环境进行了专项优化，采用先进的CDN加速技术，确保深夜时段观影不缓冲、不卡顿。',
                },
              },
              {
                '@type': 'Question',
                name: '支持哪些设备观看？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '夜猫电影院支持全平台观看，无论是电脑、平板还是手机，都能获得流畅的高清观影体验。',
                },
              },
              {
                '@type': 'Question',
                name: '影片更新频率如何？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '我们保持每日更新，热播剧集同步上线，最新电影第一时间收录。每周新增超过200部影视作品。',
                },
              },
              {
                '@type': 'Question',
                name: '观看时需要注册账号吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '不需要！夜猫电影院无需注册即可直接观看所有内容，省去繁琐的注册流程。',
                },
              },
              {
                '@type': 'Question',
                name: '画质怎么样？支持高清吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '所有影片均支持高清甚至超清画质，我们采用智能码率适配技术，根据您的网络环境自动调整最佳画质。',
                },
              },
            ],
          })}
        </script>
      </Helmet>

      <main>
        <HeroSection />
        <CategorySection />
        <FeatureSection />
        <ArticleSection />
        <FAQSection />
        <NewsletterSection />
      </main>
    </>
  );
}